export default __webpack_public_path__ + "static/media/notify.adfbef5b.wav";